export default __webpack_public_path__ + "static/media/regulatory--turn-right--g1.8b3bf63e.png";